import axios from "axios";
import API_BASE_URL from "./apiConfig";

const API_URL = `${API_BASE_URL}/api`;

const medicalRecordService = {
  async getMedicalRecords() {
    try {
      const response = await axios.get(`${API_URL}/medical-records`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  async getMedicalRecordById(id) {
    try {
      const response = await axios.get(`${API_URL}/medical-records/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  async getMedicalRecordsByAppointment(appointmentId) {
    try {
      const response = await axios.get(
        `${API_URL}/medical-records/appointment/${appointmentId}`,
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  async createMedicalRecord(recordData) {
    try {
      const response = await axios.post(
        `${API_URL}/medical-records`,
        recordData,
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  async updateMedicalRecord(id, recordData) {
    try {
      const response = await axios.put(
        `${API_URL}/medical-records/${id}`,
        recordData,
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  async deleteMedicalRecord(id) {
    try {
      const response = await axios.delete(
        `${API_BASE_URL}/medical-records/${id}`,
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};

export default medicalRecordService;
